import { useContext, useState, useRef, useEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import PageLoader from '../PageLoader';
import { AnimatePresence, motion } from 'framer-motion';
import Payment from '../Payment/Payment';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Wallet = () => {
    const { t } = useTranslation();
    const { handleCallApi, setShowToast, setToastMsg, paymentRes, setPaymentRes } = useContext(MyContext);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [wallet, setWallet] = useState(0);
    const [transactionList, setTransactionList] = useState([]);
    const [showModel, setShowModel] = useState("");
    const [paymentList, setPaymentList] = useState("");
    const [selectPayment, setSelectPayment] = useState("");

    const FetchRef = useRef(false);
    const PaymentRef = useRef(false);
    const currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        handleGetData();
    }, []);

    useEffect(() => {
        if (!paymentRes) return;
        if (PaymentRef.current) return;
        PaymentRef.current = true;
        if (paymentRes === "PaymentDone") {
            handleAddWallet();
        } else {
            setShowToast(true);
            setToastMsg("Payment was faild! please try agine");
        }
        setPaymentRes("");
    }, [paymentRes]);

    const handleGetData = async () => {
        if (FetchRef.current) return;
        FetchRef.current = true;

        const uid = secureLocalStorage.getItem("Userid");
        const ResponseW = await handleCallApi("Post", "customer/wallet", { uid });
        if (ResponseW && ResponseW.data) {
            setWallet(ResponseW.data.wallet_amount || 0);
            setTransactionList(ResponseW.data.wallet_data || []);
        } else {
            setWallet(0);
            setTransactionList([]);
        }

        const ResponseP = await handleCallApi("Get", "customer/coupon_payment");
        if (ResponseP && ResponseP.data) {
            setPaymentList(ResponseP.data.payment_list || []);
        } else {
            setPaymentList([]);
        }
        setLoading(false);
    }

    const handleAddWallet = async () => {
        const uid = secureLocalStorage.getItem("Userid");
        const PaymentData = secureLocalStorage.getItem("paymentData");
        if (PaymentData) {
            const Jsonconvert = JSON.parse(PaymentData);
            const Response = await handleCallApi("Post", "customer/add_wallet", { uid, ...Jsonconvert });
            if (Response && Response.data) {
                setShowToast(true);
                setToastMsg(Response.data.message);
            }
            FetchRef.current = false;
            handleGetData();
            setShowModel("");
            secureLocalStorage.removeItem("paymentData");
            secureLocalStorage.removeItem("transactionid");
        }
    }


    return (
        <div className="">

            <div className="max-w-4xl mx-auto p-3">
                <h1 className="font-bold text-[40px] mb-5">{t("My Wallet")}</h1>

                <div className="rounded-xl border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md mb-8">
                    <div className="p-8">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-gray-600 mb-2">{t("Total Balance")}</p>
                                <h2 className="text-5xl font-bold text-[--bg-color] mb-4">{currency}{wallet}</h2>
                                <button onClick={() => setShowModel("Payment")} className="inline-flex items-center justify-center gap-2 whitespace-nowrap hover:bg-[--bg-color-hover] italic rounded-xl text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-white shadow active:scale-95 h-11 px-6 py-2 bg-[--bg-color]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 mr-2" aria-hidden="true">
                                        <path d="M5 12h14"></path>
                                        <path d="M12 5v14"></path>
                                    </svg>
                                    {t("Add Money")}
                                </button>
                            </div>
                            <div className="w-32 h-32 rounded-full bg-[#4038ff]/10 flex items-center justify-center max-_426_:hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-16 h-16 text-[--bg-color]" aria-hidden="true">
                                    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
                                    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mb-4">{t("Transaction History")}</h2>

                {transactionList?.length >= 1
                    ? <div className="space-y-3">
                        {transactionList?.map((list, index) => {
                            return <div key={index} className="rounded-xl border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md">
                                <div className="p-6">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-4">
                                            <div className={`w-12 h-12 rounded-full flex items-center justify-center ${list.status === "2" ? "bg-red-100" : "bg-green-100"} max-_426_:hidden`}>
                                                {list.status === "2"
                                                    ? <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-red-600" aria-hidden="true">
                                                        <path d="M16 17h6v-6"></path>
                                                        <path d="m22 17-8.5-8.5-5 5L2 7"></path>
                                                    </svg>
                                                    : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-green-600" aria-hidden="true">
                                                        <path d="M16 7h6v6"></path>
                                                        <path d="m22 7-8.5 8.5-5-5L2 17"></path>
                                                    </svg>}
                                            </div>
                                            <div>
                                                <h3 className="font-semibold text-gray-900">{list.pname}</h3>
                                                <p className="text-sm text-gray-600">{list.date}</p>
                                            </div>
                                        </div>
                                        <div className="text-right leading-5">
                                            <p className={`text-xl font-bold ${list.status === "2" ? "text-red-600" : "text-green-600"}`}>{list.status === "2" ? "-" : "+"}{currency}{list.amount}</p>
                                            <p className="text-[15px] text-gray-500">{list.status === "1" ? t("Credit") : t("Debit")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                    : <div className="rounded-xl border border-gray-200 bg-white shadow p-12 text-center flex flex-col items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-16 h-16 mx-auto mb-4 text-gray-400" aria-hidden="true">
                            <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
                            <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                        </svg>
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">{t("No transactions yet")}</h3>
                        <p className="text-gray-500 mb-6">{t("Your transaction history will appear here.")}</p>
                        <div className="flex flex-wrap justify-center gap-3">
                            <button onClick={() => setShowModel("Payment")} className="bg-[--bg-color] text-white px-6 py-2.5 rounded-xl font-semibold hover:opacity-90 active:scale-95 duration-150 shadow-md">
                                {t("Add Money")}
                            </button>
                            <button onClick={() => navigate("/")} className="bg-gray-150 text-gray-700 px-6 py-2.5 rounded-xl font-semibold hover:bg-gray-200 active:scale-95 duration-150">
                                {t("Go Home")}
                            </button>
                        </div>
                    </div>}

            </div>

            <AnimatePresence initial={false}>
                {showModel === "Payment" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className='w-[500px] bg-white p-[20px] rounded-[15px] relative mx-[20px]'
                    >

                        <Payment paymentList={paymentList} setIsModel={setShowModel} index={2} selectPayment={selectPayment} setSelectPayment={setSelectPayment} Data={null} Amount={""} />

                    </motion.div>
                </div>}
            </AnimatePresence>

            <PageLoader loading={loading} />

        </div>
    )
}

export default Wallet